import { render, staticRenderFns } from "./resetpayPsd.vue?vue&type=template&id=d5242e46&scoped=true&"
import script from "./resetpayPsd.vue?vue&type=script&lang=js&"
export * from "./resetpayPsd.vue?vue&type=script&lang=js&"
import style0 from "./resetpayPsd.vue?vue&type=style&index=0&id=d5242e46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5242e46",
  null
  
)

export default component.exports